import { createSlice } from '@reduxjs/toolkit';
import { fetchCheckPay } from '../action/checkPaymentAction';
const initialState = {
    checkPay: [],
    checkPay2: [],
    isLoader: false
};
export const checkPaySlice = createSlice({
    initialState,
    name: 'checkPay',
    reducers: {},
    extraReducers: {
        [fetchCheckPay.fulfilled.type]: (state, action) => {
            state.checkPay2 = action.payload[0];
            state.checkPay = action.payload[1];
            state.isLoader = false;
        },
        [fetchCheckPay.pending.type]: (state) => {
            state.isLoader = true;
        }
    }
});
export default checkPaySlice.reducer;
